<div class="modal-apollo">
	<div class="modal-apollo__container">
		<span class="modal-apollo__title">
			<strong>If your designs aren’t aligned or you’re using photos you can align them here.</strong>
		</span>
		<span class="modal-apollo__description">
			(You can always do it later in the <strong>toolbar</strong>)
		</span>
		<div class="modal-apollo__btn_graph">
			<core-helpers-forms-button-white class="compare-action" [text]="'Align'" (submit)="actionButton('align')"></core-helpers-forms-button-white>
			<core-helpers-forms-button-white class="compare-action" [text]="'Dismiss'" (submit)="actionButton('dismiss')"></core-helpers-forms-button-white>
		</div>
	</div>
</div>
